import { RouteSlotInput, SidebarGroup } from '@luks/ui';
import { useEffect, useState } from 'react';

import { LiveEventFragment } from '../../../generated/queries';
import { mapEvent } from './EventSearch';

export const mapContextualEvent = (
  input: ContextualEventFragment,
): RouteSlotInput<typeof SidebarGroup, 'items', 'EventItem'> => {
  const inFuture = (event: ContextualEventFragment['event']) => {
    // LUKSD-48 Display only future events.
    const today = new Date().toISOString().substring(0, 10);
    return !!event && today < event.endDate;
  };
  return {
    key: 'EventItem',
    input: function useContextualEvent() {
      const event = inFuture(input.event) ? input.event : null;
      const [eventToDisplay, setEventToDisplay] = useState(event);
      useEffect(() => {
        // Filter events in browser because the page could have been rendered on
        // other day.
        setEventToDisplay(event && inFuture(event) ? event : undefined);
      }, [event]);
      return [
        {
          event: eventToDisplay
            ? mapEvent(eventToDisplay as LiveEventFragment)
            : undefined,
        },
        200,
      ];
    },
  };
};
